import { useState } from 'react'
import useOnPremAgentClient from '~/api/OnPremAgentClient/useOnPremAgentClient'
import {
  DataIngestor,
  GenerateTestDataRequest,
} from '~/api/onPremAgent/dataIngestorsAPI'
import Button from '~/components/buttons/Button'
import { StructuredDataFormData } from '~/components/StructuredDataForm/StructuredDataForm'
import Toaster from '~/components/Toaster'
import GenerateTestDataForm from './GenerateTestDataForm'
import cs from './generate_test_data.scss'

export default function GenerateTestData(props: { dataIngestor: DataIngestor }) {
  const client = useOnPremAgentClient()
  const [testDataParams, setTestDataParams] = useState<StructuredDataFormData>({})
  const { dataIngestor } = props
  const generateTestData = async () => {
    try {
      await client.dataIngestors.generateTestData(
        dataIngestor.uuid,
        testDataParams as GenerateTestDataRequest,
      )

      // Reset form after form submission
      setTestDataParams({})
      Toaster.show({
        message: 'Generated new test data.',
        intent: 'success',
      })
    } catch (_e) {
      Toaster.show({
        message: 'Failed to generate test data.',
        intent: 'danger',
      })
    }
  }

  return (
    <div className={cs.generateTestData}>
      <div className={cs.formContainer}>
        <GenerateTestDataForm
          className={cs.configForm}
          ingestorUuid={dataIngestor.uuid}
          testDataParams={testDataParams}
          setTestDataParams={setTestDataParams}
        />
      </div>
      <div className={cs.footer}>
        <Button
          type='primary'
          label='Generate Test Data'
          onClick={generateTestData}
          className={cs.button}
          disabled={dataIngestor.status !== 'live'}
        />
      </div>
    </div>
  )
}
